import * as React from 'react';
import type { SVGProps } from 'react';
const SvgShow = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} fill="none" viewBox="0 0 28 28" {...props}>
        <path
            fill="#5E5E5E"
            d="M12.054 9a3.02 3.02 0 0 0-3 3c0 1.642 1.358 3 3 3 1.64 0 3-1.358 3-3s-1.36-3-3-3"
        />
        <path
            fill="#5E5E5E"
            d="M12.054 5c7.62 0 9.92 6.595 9.949 6.684l.105.316-.106.316c-.028.089-2.328 6.684-9.948 6.684-7.617 0-9.917-6.59-9.949-6.684L2 12l.106-.316C2.136 11.59 4.436 5 12.054 5m0 2c-5.348 0-7.422 3.842-7.926 5 .502 1.154 2.575 5 7.926 5 5.348 0 7.423-3.842 7.926-5-.502-1.154-2.575-5-7.926-5"
        />
    </svg>
);
export default SvgShow;
